<template lang="pug">
  .component.component-subscription.subscription
    .card(v-if="$is('listing')")
      .inner-content
        card7(:showBullets="true", :showAction="true", v-if="$is('listing')", :shrink="shrink")
          .field-subscription-dropdown-buttons(slot="actionBullets")
            dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'top'")
              subscription-action-buttons(:subscription="item")
          subscription-fields(slot="n1", :item="item", :fieldName="'subscription-id-and-client'")
          subscription-fields(slot="n2", :item="item", :fieldName="'plan-name'")
          subscription-fields(slot="n3", :item="item", :fieldName="'subscription-booking-mode'")
          subscription-fields(slot="n4", :item="item", :fieldName="'subscription-max-drivers'")
          subscription-fields(slot="n5", :item="item", :fieldName="'plan-billing-cycle'")
          .field-auto-renew.iconized(slot="n6")
            i.pm-icon.subs-expiry
            .field-value Start: {{$dateFormat(item.start,  $toMomentFormat(configuration.locale.locale_date_format.value))}}

            .field-value(v-if="!expired",) {{daysToExpiry}} days
            .field-value(v-else-if="item.start === null || item.end === null") Unactive
            .field-value.expired(v-else) {{$dateFormat(item.end,  $toMomentFormat(configuration.locale.locale_date_format.value))}}
          strong(slot="n7") {{item.plan.cost}}{{currency}}/{{$daysNumberToHuman(item.plan.billing_cycle)}}

          .field-url-detail(slot="actionPage")
            router-link(:to="{name:'subscription', params:{id:item.id}}")
              i.fa.fa-angle-right.fa-3x.action
    .driver-data(v-if="$is('driver-data') || $is('test-data')")
      ul.accordion.subscription-accordion(data-accordion v-f-accordion="" data-allow-all-closed="true")
        li.accordion-item(data-accordion-item)
          a.accordion-title(href="#")
            backoffice-subscription(:item="item", :type="'card-header-include'")
          div.accordion-content(data-tab-content)
            backoffice-subscription(:item="item", :type="'subscription-action-details'")
    .card-header-include(v-if="$is('card-header-include')")

      card6(:showBullets="true", :showAction="false")
        //h3(slot="n1") {{item.plan.name}}
        subscription-fields(slot="n1", :item="item", :fieldName="'plan-name'")
        .field-expire-in(slot="n1")
          .field-value(v-if="item.start && item.end")
            .expire-days EXPIRE IN: {{daysToExpiry}} days
            .expire-date {{item.end}}
          .field-value(v-else) Unactive subscription
        subscription-fields(slot="n2", :item="item", :fieldName="'subscription-booking-mode'")
        subscription-fields(slot="n3", :item="item", :fieldName="'subscription-max-drivers'")
        subscription-fields(slot="n4", :item="item", :fieldName="'plan-billing-cycle'")
        .field-auto-renew.iconized(slot="n5")
          i.pm-icon.subs-expiry
          .field-value(v-if="!expired") {{daysToExpiry}} days
          .field-value(v-else-if="item.start === null || item.end === null") Unactive
          .field-value(v-else) {{item.end}}
        strong(slot="n6") {{item.plan.cost}}{{currency}}/{{$daysNumberToHuman(item.plan.billing_cycle)}}
    .subscription-action-details(v-if="$is('subscription-action-details')")
      plan(:item="item.plan", :type="'plan-data'")
      h3 My Drivers
      hr
      driver-subscription-slots(:subscriptionId="item.id", :clientId="item.client.id", :maxDrivers="item.plan.max_drivers", :subscribedDrivers="item.drivers")
      .subscription-action
        button.pm-button-iconbutton(v-on:click="edit") Edit
          i.fa.fa-pencil
        router-link.button.pm-button-iconbutton(:to="{name:'subscription', params:{id:item.id}}") Details
          i.fa.fa-info

</template>
<script type="text/babel">
  import Driver from "./Driver.vue";
  import Accordion from "../../components/structure/foundation/Accordion";
  import Card7 from "components/structure/Card7";
  import Dropdown from "../structure/foundation/Dropdown";
  import SubscriptionActionButtons from "../structure/ui/actions/SubscriptionActionButtons";
  import Card5 from "../structure/Card5";
  import Card6 from "../structure/Card6";
  import Plan from "./Plan";
  import DriverSubscriptionSlots from "../structure/ui/DriverSubscriptionSlots";
  import MaggieHelper from "src/maggieHelper";
  import SubscriptionSmartEdit from "components/backoffice/smartedits/SubscriptionEdit";
  import SubscriptionFields from "../structure/ui/entity-fields/SubscriptionFields.vue";
  import moment from "moment";
  import {mapState} from 'vuex'

  export default {
    name: "BackofficeSubscription",
    components: {
      SubscriptionFields,
      DriverSubscriptionSlots,
      Plan,
      Card6,
      Card5,
      SubscriptionActionButtons,
      Dropdown,
      Card7,
      Driver,
      Accordion
    },
    data() {
      return {
        shrink: [{n5: true}]
      }
    },
    methods: {
      edit() {
        MaggieHelper.openRightPanel({
          component: SubscriptionSmartEdit,
          props: {
            item: this.item
          }
        })
      },

    },
    computed: {
      expired() {
        if (this.item.start === null || this.item.end === null) {
          return true
        }
        var end = moment(this.item.end)
        var today = moment()
        return (this.item.start && this.item.end) && today.isAfter(end)
      },
      daysToExpiry() {
        return this.$diffInDays(this.item.end, new Date())
      },
      ...mapState({
        configuration: state => state.configuration,
      }),
      currency() {
        return this.configuration.commercial.commercial_currency.value
      },
    },
    props: {
      item: Object,
      type: {
        type: String,
        default: ""
      }
    },
  }
</script>
<style lang="sass" rel="stylesheet/sass">
  .component-subscription
    .accordion-title
      color: inherit
    .expired
      color: rgb(225, 13, 90)
      font-weight: bold
</style>



// WEBPACK FOOTER //
// Subscription.vue?43d87e57